import { render } from "./TrainingResult.vue?vue&type=template&id=4e89130c"
import script from "./TrainingResult.vue?vue&type=script&lang=js"
export * from "./TrainingResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.12_webpack@5.96.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__